export default __webpack_public_path__ + "ffcb28400772a5ce40a71fa7e245f310.png";